<template>
    <div>
        <MenuItem :to="resolvePath(menu.path)" :replace="menu.replace" :target="menu.target"
            :name="menu.path || menu.id" @click.native="handleClick(menu.path)">
        <i-menu-side-title :menu="menu" :hide-title="hideTitle" />
        <!-- <Badge class="i-layout-menu-side-badge" v-if="badgeData" v-bind="badgeData" /> -->
        <Badge class="i-layout-menu-side-badge" v-if="badgeData" :count="badgeData.badge" v-bind="badgeData" />
        </MenuItem>
    </div>
</template>
<script>
import iMenuSideTitle from './menu-title';
import clickItem from '../mixins/click-item';
import menuBadge from '../mixins/menu-badge';

export default {
    name: 'iMenuSideItem',
    components: { iMenuSideTitle },
    mixins: [clickItem, menuBadge],
    props: {
        menu: {
            type: Object,
            default() {
                return {}
            }
        },
        hideTitle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //往 layout 外部跳转的接口
            outerPathArray: [
               // "/orderManagement/createOrder",
              "/knowledgeBase/createInformation",
            ]
        }
    },
    mounted() {
    },
    methods: {
        /*
            判断 :to 中跳转的路由是不是需要在<新窗口>打开的
            如果 是 则不执行 :to 里面的逻辑，执行 menuClick
                否 则执行 resolvePath
        */
        resolvePath(path) {
            if (this.outerPathArray.includes(path)) {
                return ""
            } else {
                return path
            }
        },
        handleClick(path) {
            if (this.outerPathArray.includes(path)) {
                window.open(this.$router.resolve(path).href, '_blank');
            }
        },
    }
}
</script>
<style lang="less" scoped>
/deep/.ivu-badge-count {
    height: 16px;
    border-radius: 8px;
    min-width: 16px;
    line-height: 14px;
    padding: 0 4px;
    font-size: 12px;
}
</style>
